<template>
  <h6 class="card-title"><slot></slot></h6>
</template>

<style scoped>
.card-title {
  font-size: 1.15rem;
  margin: 1rem 1rem;
}

.card img {
  object-fit: cover;
  max-width: 100%;
}
</style>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'CardTitle',
  setup() {
    
  },
})
</script>

